import { useContext } from 'react';

import { SupersetContext } from './superset-context';

export function useSupersetContext() {
  const context = useContext(SupersetContext);
  if (!context) {
    throw new Error('useSupersetContext must be used inside SupersetProvider');
  }
  return context;
}
